<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'lg' }" :title="String($t('management_page.windows_process_service_check_settings'))")
    .form
      p(v-html="$t('management_page.windows_process_service_detection')")
      .control-wrap
        .add
          b-row
            b-col.d-flex.align-items-center(cols="2") {{$t('management_page.add_excluding_exe')}}
            b-col.d-flex.align-items-center(cols="10")
              b-form-input.d-inline-block(v-model="text" size="sm")
              b-button(size="sm" @click="add")
                icon(name="plus")
        .list
          .scroll
            b-row(v-for="(item, index) of form.list" :key="index")
              b-col.d-flex.align-items-center(cols="2")
              b-col.d-flex.align-items-center(cols="10")
                b-form-input.d-inline-block(v-model="form.list[index]" size="sm" placeholder="")
                b-button(size="sm" @click="remove(index)")
                  icon(name="minus")

    .modal-footer
      b-btn(size="sm" @click="visible = false" pill) {{$t('cancel')}}
      b-btn(size="sm" variant="primary" @click="submit" pill) {{$t('save')}}
</template>

<script>
import { CompanyFunctionAPI } from "@/api"
import _ from "lodash"
import Dialogs from "@/components/mixins/dialog/index.vue"

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
  },
  components: {
    Dialogs,
  },
  computed: {
    // list() {
    //   return this.form.value.split(";")
    // },
  },
  watch: {
    show(newVal) {
      this.visible = newVal
      if (newVal) {
        this.form.value = this.value
      }
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
    "form.value": {
      handler(newVal) {
        this.form.list = newVal.split(";")
      },
      deep: true,
    },
  },
  data() {
    return {
      visible: false,
      text: "",
      form: {
        request_type: "process_check_list",
        value: "",
        list: [],
      },
    }
  },
  methods: {
    add() {
      const text = _.cloneDeep(this.text)
      this.form.list.push(text)
      this.text = ""
    },
    remove(index) {
      this.form.list.splice(index, 1)
    },
    submit() {
      const params = _.cloneDeep(this.form)
      params.value = params.list.join(";")
      CompanyFunctionAPI.put("", params).then(res => {
        const { status } = res
        if (status === 200) {
          this.$awn.success(String(this.$t('toasts_message.save_success')))
          this.$emit("update:value", this.form.value)
          this.$emit("update:show", false)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.form {
  padding: 10px 30px;
}

.add {
  padding-bottom: 20px;
}
.list {
  .row {
    padding-bottom: 10px;
  }
  .scroll {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: 114px;
  }
}
</style>
